import React, { useState, useEffect, useMemo } from 'react';
import './extracted-data-confirmation.scss';
import { getDocumentUploadPlaceholderSrc } from '../../utils/documentUploadPlaceholder';

export interface ExtractedDataField {
  label: string;
  value: string;
}

interface ExtractedDataConfirmationModalProps {
  isOpen: boolean;
  title: string;
  data: ExtractedDataField[];
  onConfirm: (editedData?: ExtractedDataField[]) => void;
  onCancel?: () => void;
  documentType?: string;
  previewImageSrc?: string;
}

export default function ExtractedDataConfirmationModal({
  isOpen,
  title,
  data,
  onConfirm,
  onCancel,
  documentType,
  previewImageSrc,
}: ExtractedDataConfirmationModalProps) {
  const [editedData, setEditedData] = useState<ExtractedDataField[]>([]);

  // Initialize edited data when modal opens or data changes
  useEffect(() => {
    if (isOpen && data) {
      setEditedData(data.map(field => ({ ...field })));
    }
  }, [isOpen, data]);

  const handleFieldChange = (index: number, newValue: string) => {
    const updated = [...editedData];
    updated[index] = { ...updated[index], value: newValue };
    setEditedData(updated);
  };

  const handleConfirm = () => {
    onConfirm(editedData);
  };

  const displayTitle = title.includes("بطاقة الرقم القومي - الوجه الأمامي")
    ? "بيانات وجه البطاقة"
    : title.includes("بطاقة الرقم القومي - الوجه الخلفي")
      ? "بيانات ظهر البطاقة"
      : title;

  const previewDisplaySrc = useMemo(() => {
    const fromTitle = getDocumentUploadPlaceholderSrc(title);
    const fromDoc = documentType ? getDocumentUploadPlaceholderSrc(documentType) : null;
    return fromTitle ?? fromDoc ?? previewImageSrc ?? null;
  }, [title, documentType, previewImageSrc]);

  if (!isOpen) return null;

  return (
    <div className="extracted-data-modal-overlay">
      <div className="extracted-data-modal">
        {previewDisplaySrc && (
          <div className="extracted-data-modal-preview-wrap" aria-hidden>
            <img
              className="extracted-data-modal-preview-image"
              src={previewDisplaySrc}
              alt=""
            />
          </div>
        )}
        <div className="extracted-data-modal-header">
          <h3>{displayTitle}</h3>
        </div>

        <div className="extracted-data-modal-content">
          <p className="confirmation-message">
            هذه هي البيانات المستخرجة من الصورة. من فضلك راجعها واختر أحد الخيارات.
          </p>

          <div className="data-fields">
            {editedData.map((field, index) => (
              <div key={index} className="data-field">
                <label className="field-label">{field.label}:</label>
                <input
                  type="text"
                  className="field-value field-input"
                  value={field.value || ''}
                  onChange={(e) => handleFieldChange(index, e.target.value)}
                  placeholder="غير متوفر"
                />
              </div>
            ))}
          </div>
        </div>

        <div className="extracted-data-modal-footer">
          <button
            className="btn-confirm"
            onClick={handleConfirm}
          >
            تاكيد
          </button>
          {onCancel && (
            <button
              className="btn-cancel"
              onClick={onCancel}
            >
              إلغاء
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

